<template>
  <div>
    <a-modal modal-id="add-product">
      <div slot="title">Add Product</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-12 m-b-sm">
            <label for="">Code</label>
            <input type="text" name="" id="" class="form-control" placeholder="Code" v-model="addProduct.Code">
          </div>
          <div class="col-lg-12 m-b-sm">
            <label for="">Name</label>
            <input type="text" name="" id="" class="form-control" placeholder="Name" v-model="addProduct.Name">
          </div>
          <div class="col-lg-12 m-b-sm">
            <label for="">Description</label>
            <textarea class="form-control" placeholder="Description" v-model="addProduct.Description" rows="5"></textarea>
          </div>
          <div class="col-lg-12 m-b-sm">
            <label for="">Price</label>
            <input type="number" name="" id="" class="form-control" placeholder="Price"
                   v-model="addProduct.SalesDetails.UnitPrice">
          </div>
          <div class="col-lg-12 m-b-sm">
            <label for="">Account</label>
            <v-select v-model="addProduct.SalesDetails.AccountCode" index="Code" label="Name"
                      :options="accounts"></v-select>
          </div>
          <div class="col-lg-12 m-b-sm">
            <button class="btn btn-primary btn-sm pull-right" @click="saveItem"><i class="fa fa-save"></i> Save</button>
          </div>
        </div>
      </div>
    </a-modal>
    <in-wrapper>
      <in-ibox>
        <div slot="title">
          Products
          <a class="btn btn-primary btn-xs pull-right" data-toggle="modal" data-target="#add-product"><i
            class="fa fa-plus" @click="resetModal"></i> New Product</a>
        </div>
        <div slot="content" class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-2">
                <input type="text" placeholder="Code" class="form-control" v-model="filters.code" @keydown.enter="loadItems">
              </div>
              <div class="col-lg-2">
                <input type="text" placeholder="Name" class="form-control" v-model="filters.name" @keydown.enter="loadItems">
              </div>
              <div class="col-lg-2">
                <v-select placeholder="Account" :options="accounts" index="Code" label="Name" multiple="multiple" v-model="filters.account" @input="loadItems"></v-select>
              </div>
            </div>
            <table class="table table-striped table-hover m-t-sm">
              <thead>
              <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Account</th>
                <th>Price</th>
                <th style="width: 50px;"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in items" :key="item.ItemID">
                <td>{{ item.Code }}</td>
                <td>{{ item.Name }}</td>
                <td>
                  {{ item.SalesDetails.AccountCode ? accounts.filter(a => a.Code === item.SalesDetails.AccountCode)[0].Name : '/' }}
                </td>
                <td>{{ item.SalesDetails.UnitPrice }}</td>
                <td><button class="btn btn-xs btn-primary pull-right" @click="editItem(item)" data-toggle="modal" data-target="#add-product"><i class="fa fa-edit"></i> Edit</button></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </in-ibox>
    </in-wrapper>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  data () {
    return {
      filters: {},
      items: [],
      accounts: [],
      addProduct: {
        SalesDetails: {}
      }
    }
  },
  mounted () {
    this.loadItems()
    this.loadAccounts()
  },
  methods: {
    async loadItems () {
      let filters = new URLSearchParams(this.filters).toString()
      this.items = (await axios.get(`/integrations/xero/items?` + filters)).data
    },
    async loadAccounts () {
      this.accounts = (await axios.get(`/integrations/xero/accounts`)).data
    },
    async saveItem () {
      try {
        await axios.post(`/integrations/xero/items`, this.addProduct)
        this.$toastr.success('Product added')
        $('#add-product').modal('hide')
        await this.loadItems()
      } catch (e) {
        this.$toastr.error(e)
      }
    },
    resetModal () {
      this.addProduct = {
        SalesDetails: {}
      }
    },
    editItem (item) {
      this.addProduct = {
        Code: item.Code,
        Name: item.Name,
        Description: item.Description,
        SalesDetails: {
          UnitPrice: item.SalesDetails.UnitPrice,
          AccountCode: item.SalesDetails.AccountCode
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Billing/Items.vue